<script lang="ts" setup>
import { useStageSwitchersStore } from '@/stores/stageSwitchers';
import { useVehicleStore } from '@/stores/vehicle';

import { DynamicStage } from '@dh-io-owpi/dynamic-stage/src/lib';
import { useAemData } from '@/composables/useAemData';
import { type CtaTypeMap, useStageCtas } from '@dh-io-owpi/shared-dynamic-stage/src/composables/useStageCtas';
import { computed } from 'vue';

const aemData = useAemData();

const switcherStore = useStageSwitchersStore();
const vehicleStore = useVehicleStore();

// TODO: we need a better error handling
const joinedErrors = computed(
  () => [vehicleStore.errorMessage, ...switcherStore.errors.value].filter(Boolean) as string[],
);

// TODO: we're hard-coding these for now
const ctasMap: CtaTypeMap = { primary: 'shop', secondary: 'configurator' };

const deeplinksData = {
  country: aemData.country,
  language: aemData.language,
  modelSeries: aemData.modelSeries,
  brandId: switcherStore.brandId,
};
const stageVehicle = computed(() => vehicleStore.stage);
const ctas = useStageCtas(deeplinksData, ctasMap, stageVehicle);
</script>

<template>
  <DynamicStage
    :isAemEditMode="aemData.isAemEditMode"
    :aemData="aemData"
    :ctas="ctas"
    :errors="joinedErrors"
    :purchasePriceTooltip="aemData.purchasePriceTooltip"
    :stageVehicle="vehicleStore.stage"
    :stageStyles="switcherStore.styles.value"
    :selectedStyle="switcherStore.selectedStyle.value"
    :stagePaints="switcherStore.paints.value"
    :selectedPaint="switcherStore.selectedPaint.value"
    :brandId="vehicleStore.brandId"
    @switchStyle="switcherStore.switchStyle"
    @switchPaint="switcherStore.switchPaint"
  />
</template>
